module.exports = __webpack_public_path__ + "static/img/demo-image-pt-01.0eef3ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo-image-pt-01.png
// module id = vRE0
// module chunks = 1